import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { VacationService } from '../services/vacation.service';
import { Vacation } from '../beans/vacation';

@Component({
	selector: 'app-vacation-dialog',
	templateUrl: './vacation-dialog.component.html',
	styleUrls: ['./vacation-dialog.component.scss']
})
export class VacationDialogComponent {

	@ViewChild('modalRef') modalRef: ModalDirective;

	vacations: Vacation[] = [];
	newStartDateStr = '';
	newEndDateStr = '';
	error = '';

	constructor(private vacationService: VacationService) { }

	show(initialDate?: Date) {
		this.error = '';
		if (initialDate) {
			const iso = initialDate.getFullYear() + '-' +
				('0' + (initialDate.getMonth() + 1)).slice(-2) + '-' +
				('0' + initialDate.getDate()).slice(-2);
			this.newStartDateStr = iso;
			this.newEndDateStr = iso;
		} else {
			this.newStartDateStr = '';
			this.newEndDateStr = '';
		}
		this.clearOverlaps();
		this.loadVacations();
		this.modalRef.show();
	}

	private loadVacations() {
		this.vacationService.getMy().subscribe(
			list => { this.vacations = list; },
			() => { this.error = 'Грешка при зареждане на отпуските.'; }
		);
	}

	save() {
		this.error = '';
		this.clearOverlaps();

		if (!this.newStartDateStr || !this.newEndDateStr) {
			this.error = 'Моля, попълнете начална и крайна дата.';
			return;
		}
		if (this.newStartDateStr > this.newEndDateStr) {
			this.error = 'Началната дата не може да е след крайната.';
			return;
		}

		// Check overlap with existing vacations
		const overlapping = this.findOverlapping(this.newStartDateStr, this.newEndDateStr);
		if (overlapping.length > 0) {
			overlapping.forEach(v => (v as any)._overlap = true);
			this.error = 'Новата отпуска се застъпва с маркираните периоди!';
			return;
		}

		const startStr = this.newStartDateStr;
		const endStr = this.newEndDateStr;

		// Check conflicts with hearings
		this.vacationService.checkConflicts(startStr, endStr).subscribe(
			conflicts => {
				if (conflicts && conflicts.length > 0) {
					const msg = 'Внимание! Имате насрочени дела в този период:\n\n' +
						conflicts.map(c => '- Дело ' + (c.caseNumber || '') + ' на ' +
							this.formatBgDate(c.date) + ' (' +
							(c.type === 'civil' ? 'гражданско' : 'наказателно') + ')').join('\n') +
						'\n\nЖелаете ли да продължите?';
					if (!confirm(msg)) {
						return;
					}
				}
				this.doSave(startStr, endStr);
			},
			() => {
				this.doSave(startStr, endStr);
			}
		);
	}

	private doSave(startStr: string, endStr: string) {
		this.vacationService.add({ startDate: startStr, endDate: endStr } as any).subscribe(
			() => {
				this.newStartDateStr = '';
				this.newEndDateStr = '';
				this.loadVacations();
			},
			err => {
				this.error = (err.error && err.error.message) || 'Грешка при запис.';
			}
		);
	}

	delete(v: Vacation) {
		if (!confirm('Сигурни ли сте, че искате да изтриете тази отпуска?')) {
			return;
		}
		this.vacationService.delete(v.id).subscribe(
			() => { this.loadVacations(); },
			() => { this.error = 'Грешка при изтриване.'; }
		);
	}

	private clearOverlaps() {
		this.vacations.forEach(v => (v as any)._overlap = false);
	}

	private findOverlapping(startStr: string, endStr: string): Vacation[] {
		return this.vacations.filter(v => {
			const vStart = this.toIsoFromBackend(v.startDate);
			const vEnd = this.toIsoFromBackend(v.endDate);
			if (!vStart || !vEnd) return false;
			return startStr <= vEnd && endStr >= vStart;
		});
	}

	private toIsoFromBackend(d: any): string {
		if (!d) return null;
		if (Array.isArray(d) && d.length === 3) {
			return d[0] + '-' + ('0' + d[1]).slice(-2) + '-' + ('0' + d[2]).slice(-2);
		}
		if (typeof d === 'string') return d;
		return null;
	}

	// Converts backend date to DD.MM.YYYY
	private formatBgDate(d: any): string {
		if (!d) return '';
		if (Array.isArray(d) && d.length === 3) {
			return ('0' + d[2]).slice(-2) + '.' + ('0' + d[1]).slice(-2) + '.' + d[0];
		}
		if (typeof d === 'string' && d.includes('-')) {
			const p = d.split('-');
			return p[2] + '.' + p[1] + '.' + p[0];
		}
		return '' + d;
	}

	formatDate(d: any): string {
		return this.formatBgDate(d);
	}
}
